import React, { useEffect } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { fromUnixTime, compareAsc  } from 'date-fns';
export const PrivateRoute = ({component: Component, ...rest}: any) => {
  return(
      <Route {...rest}
        render={props => localStorage.getItem('@authToken') ?
        <Component {...props} /> :
        <Redirect to={{
          pathname: '/login',
          state: { from: props.location}
        }} />
        }
      />
    )
  }
